/**
 * @author wangyingxu1
 * 环境变量配置
 */

// 环境变量
const isTextEnv: boolean =
  location.host.indexOf('localhost') > 0 ||
  (location.host.indexOf('staff') === -1 && location.host.indexOf('test') > 0);

// 测试环境适配
let env: string = 'env1'; // env1 | env2 ....
if (isTextEnv) {
  const envStr: string = location.host.split('.test.xdf.cn')[0].split('-').slice(-1)[0];
  if (envStr.indexOf('env') !== -1) {
    env = envStr;
  }
}

// 后端接口域名
const prodDomain: any = { // 生产
  base: `${location.protocol}//iteach-authcenter-api.staff.xdf.cn`
};
const devDomain: any = { // 测试
  base: `${location.protocol}//iteach-authcenter-api.test.xdf.cn`
};

// url地址
const prodUrl: { [key: string]: string } = { // 生产
  logout: `${location.protocol}//iteach-jiaoyan.xdf.cn`
};
let devUrl: { [key: string]: string } = { // 测试
  logout: `${location.protocol}//pop-iteach-jiaoyan-h5-${env}.test.xdf.cn`
};
if (location.origin.indexOf('cloud') > -1) {
  devUrl = {
    logout: `${location.protocol}//iteach-cloud-jiaoyan-h5.test.xdf.cn`
  };
}

let domainMap: { [key: string]: string } = prodDomain;
let urlMap: { [key: string]: string } = prodUrl;
if (isTextEnv) {
  domainMap = devDomain;
  urlMap = devUrl;
}

// 集团教研系统Id
const sysId: string = 'bbfa1f1abdcd487a82c8bae5f30cd58b';

const setDomainUrl: any = (key: string, value: string): void => {
  domainMap[key] = value;
};

export {
  domainMap,
  urlMap,

  isTextEnv,
  env,
  sysId,

  setDomainUrl
};
